import { format } from 'date-fns';
export const ISO_FORMAT = 'yyyy-MM-dd';
export const FORMAT = 'DD/MM/YYYY';
export const DEFAULT_DATE = format(new Date(), ISO_FORMAT);
export const DEFAULT_ACTION_LABELS = {
  apply: 'Filtrar',
  cancel: 'Cancelar',
  reset: 'Limpar'
};
